import errorManager from '@/rollbar.js';

const choiseFilter = () => {
  $('.q_hidden_procedures').val([null]);

  if (event.currentTarget.value === '1') {
    $('#q4_dateout_gt').val([new Date()]);
    $('#q4_dateout_null').val([1]);
    $('#q4_m').val(['or']);
  } else if (event.currentTarget.value === '2') {
    $('#q4_dateout_lteq').val([new Date()]);
  }

  $('#form-search-procedures').submit();
};

const initComponentsModules = () => {
  var radioButtons = document.getElementsByClassName('search-procedures');
  for (var i = 0; i < radioButtons.length; i++) {
    radioButtons[i].addEventListener('click', choiseFilter, false);
  }
};

const init = () => {
  try {
    initComponentsModules();
  } catch (e) {
    errorManager(e);
  }
};

window.PatologiesFilters = {
  init,
};
